import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PLayout from "./PLayout";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { myQuizzes } from "@/lib/api";

function groupByModule(items, lang) {
  const filtered = items.filter((q) => !q.language || q.language === lang);
  const map = {};
  for (const q of filtered) {
    const key = q.module || "—";
    (map[key] = map[key] || []).push(q);
  }
  const groups = Object.entries(map).map(([module, list]) => ({ module, list }));
  groups.sort((a, b) => a.module.localeCompare(b.module));
  return groups;
}

export default function Quizzes() {
  const { lang } = useApp();
  const t = useAppUi(lang);
  const [items, setItems] = useState(null);
  useEffect(() => { myQuizzes().then(setItems).catch(() => setItems([])); }, []);

  const groups = items ? groupByModule(items, lang) : [];

  return (
    <PLayout>
      <h1 className="rbl-h1" style={{ fontSize: 36 }}>✅ {t("qzTitle")}</h1>
      <p className="rbl-intro">{t("qzIntro")}</p>
      <div style={{ marginTop: 24 }} data-testid="quiz-list">
        {items === null && <div className="rbl-spinner" />}
        {items && groups.length === 0 && <p style={{ color: "var(--muted)" }}>{t("qzNone")}</p>}
        {groups.map((g) => (
          <div key={g.module} style={{ marginBottom: 28 }} data-testid={`quiz-group-${g.module}`}>
            <h2 className="rbl-section-title" style={{ marginBottom: 12 }}>{g.module}</h2>
            {g.list.map((q) => (
              <Link key={q.id} to={`/app/quizzes/${q.id}`} className="rbl-list-item" data-testid={`quiz-item-${q.id}`}>
                <div>
                  <div style={{ fontWeight: 700 }}>{q.title}</div>
                  <div style={{ color: "var(--muted)", fontSize: 13 }}>{(q.questions || []).length} {t("questions")}</div>
                </div>
                {q.attempt ? <span className="rbl-badge ok">{q.attempt.score}%</span> : <span className="rbl-badge todo">{t("badgeTodo")}</span>}
              </Link>
            ))}
          </div>
        ))}
      </div>
    </PLayout>
  );
}
